// extracted by mini-css-extract-plugin
module.exports = {"partner":"Partner_partner__1sCSU","image":"Partner_image__1Js23","thanks":"Partner_thanks__tTI64"};